import { render, staticRenderFns } from "./cowInseminationDueBetweenTwoDays.vue?vue&type=template&id=5c0a1f08&scoped=true&"
import script from "./cowInseminationDueBetweenTwoDays.vue?vue&type=script&lang=js&"
export * from "./cowInseminationDueBetweenTwoDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a1f08",
  null
  
)

export default component.exports